/* */ 
'use strict';
var util = require('./util'),
    ono = require('ono'),
    ZSchema = require('z-schema'),
    swaggerSchema = require('swagger-schema-official/schema');
module.exports = validateSchema;
initializeZSchema();
function validateSchema(api) {
  util.debug('Validating against the Swagger 2.0 schema');
  var isValid = ZSchema.validate(api, swaggerSchema);
  if (isValid) {
    util.debug('    Validated successfully');
  } else {
    var err = ZSchema.getLastError();
    var message = 'Swagger schema validation failed. \n' + formatZSchemaError(err.details);
    throw ono.syntax(err, {details: err.details}, message);
  }
}
function initializeZSchema() {
  ZSchema = new ZSchema({
    breakOnFirstError: true,
    noExtraKeywords: true,
    ignoreUnknownFormats: false,
    reportPathAsArray: true
  });
}
function formatZSchemaError(errors, indent) {
  indent = indent || '  ';
  var message = '';
  errors.forEach(function(error, index) {
    message += util.format('%s%s at #/%s\n', indent, error.message, error.path.join('/'));
    if (error.inner) {
      message += formatZSchemaError(error.inner, indent + '  ');
    }
  });
  return message;
}
